import React from "react";

type IFrameProps = {
  src: string;
  title?: string;
};

const IFrameContainer: React.FC<IFrameProps> = ({ src, title, styles }) => {
  const iframeStyles = {
    width: "100%",
    height: "100%", // Allow iframe to fill its parent's available space
    border: "0",
    allowTransparency: true,
  };
  return (
    <>
      <iframe style={iframeStyles} src={src} title={title} scrolling="no" />
    </>
  );
};

export default IFrameContainer;
